





























import { Component, Vue, Prop } from 'vue-property-decorator';
import AddSubjectForm from '../../components/addSubject/index.vue';

@Component({
  components: {
    AddSubjectForm
  }
})
export default class AddSubject extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  private data!: TypeCertification.CustomerStartupInfo;
  /**
   * @description: 返回上一步操作
   * @return {*}
   */
  private handleReturn(): void {
    this.$emit('submit', {
      status: 'select_region',
    });
  }
  /**
   * @description: 下一步操作
   * @return {*}
   */
  private handleNext() {
    const formDataRef = this.$refs.addSubjectFormRef as AddSubjectForm;
    /** 兼容老数据：原GD注册成功会默认创建一个主体，需要进入添加主体页面进行编辑主体 */
    if (this.data.sign_body_info?.account_code) {
      formDataRef.submit((formData?: TypeCertification.SignBodyInfo) => {
        /** 如果是中国大陆，直接跳转至待认证/确认步骤，如果是非中国大陆，则等待用户选择是否审核 */
        if (formData?.register_area_code === this.$enum.mine.RegisterAreaCodeEnum.CN)
          this.$emit('submit', {
            status: this.$enum.mine.CustomerStartupStatusEnum.FILL_CERTIFICATION_FORM,
          });
      }, () => {
        /** 取消审核则跳转至认证/确认步骤 */
        this.$emit('submit', {
          status: this.$enum.mine.CustomerStartupStatusEnum.FILL_CERTIFICATION_FORM,
        });
      });
      return;
    }
    formDataRef.addFirm(() => {
      this.$emit('submit', {
        status: this.$enum.mine.CustomerStartupStatusEnum.FILL_CERTIFICATION_FORM,
      });
    });
  }
}
